import React from 'react';
import { Row, Col } from 'react-bootstrap';

const LayoutDashboard3col = ({ col1, col2, sidebar, sidebarPos }) => {
  if (sidebarPos === 'left') {
    return (
      <>
        <Row>
          <Col lg={2}>
            <div className="bg-white p-3">{sidebar}</div>
          </Col>
          <Col lg={5}>
            <div className="bg-white p-5">{col1}</div>
          </Col>
          <Col lg={5}>
            <div className="bg-white p-5">{col2}</div>
          </Col>
        </Row>
      </>
    );
  }

  return (
    <>
      <Row>
        <Col lg={5}>
          <div className="bg-white p-5">{col1}</div>
        </Col>
        <Col lg={4}>
          <div className="bg-white p-5">{col2}</div>
        </Col>
        <Col lg={3}>
          <div className="bg-white p-3">{sidebar}</div>
        </Col>
      </Row>
    </>
  );
};

export { LayoutDashboard3col };
